import React from "react";

import { styled } from '@material-ui/core';
import LoadingButton from '@material-ui/lab/LoadingButton';

import { AuthMethod } from "../types/auth";

const FacebookButton = styled(LoadingButton)({
  width: '100%',
  backgroundColor: '#3b5999',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#304b84',
  }
});

const GoogleButton = styled(LoadingButton)({
  width: '100%',
  backgroundColor: '#ca3f23',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#ad351c',
  },
  marginTop: 20,
  marginBottom: 20,
})



interface Props {
  loading?: boolean;
  type: AuthMethod;
  onClick?: () => void;
}

const AuthButton: React.FC<Props> = ({ loading, type, onClick }) => {

  if (type === 'facebook.com') {
    return <FacebookButton
      onClick={onClick}
      loading={loading}
      variant="contained"
    >
      Login with Facebook
    </FacebookButton>
  }
  else if (type === 'google.com') {
    return <GoogleButton
      onClick={onClick}
      loading={loading}
      variant="contained"
    >
      Login with Google
    </GoogleButton>
  }

  return null;
};

export default AuthButton;